import * as React from 'react';

export const UserCreateCallout = () => {
    return <div className="row">
                <div className="col">
                    <p className="callout">
                        <span className="bold-span">Note:</span> 
                        The user will need to logout and log back in in order for any permission or service center changes to take affect.
                    </p>
                </div>
            </div>;
};
